module.exports = __webpack_public_path__ + "static/media/Understanding 3ds Max and Arnold as a Design Visualization Tool.dece021c.png";